import {Check} from "../../../../../components/matches/MatchChecks.tsx";

export function computeChecks(match: any): Check[] {
    const checks = [];

    // 1. Invoice number in transaction description
    if (match.transaction.description && match.document.invoice_number) {
        if (match.transaction.description.includes(match.document.invoice_number)) {
            checks.push({text: "Factuunummer in transactieomschrijving", status: "ok"});
        } else {
            checks.push({text: "Factuunummer niet in transactieomschrijving", status: "error"});
        }
    }

    // 2. Amount match
    if (match.transaction.amount !== undefined && match.document.amount !== undefined) {
        // Direct comparison of numeric values
        if (match.transaction.amount === match.document.amount) {
            checks.push({text: "Bedrag komt overeen", status: "ok"});
        } else {
            checks.push({text: "Bedrag komt niet overeen", status: "error"});
        }
    }

    // 3. Paid within 90 days
    if (match.transaction.transaction_date && match.document.document_date) {
        const transactionDate = new Date(match.transaction.transaction_date);
        const documentDate = new Date(match.document.document_date);
        const diffTime = Math.abs(transactionDate.getTime() - documentDate.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if (diffDays <= 90) {
            checks.push({text: `Betaald binnen ${diffDays} dagen`, status: "ok"});
        } else {
            checks.push({text: `Betaald na ${diffDays} dagen ( > 90 dagen)`, status: "error"});
        }
    }

    return checks;
}
